import { useQuery } from '@tanstack/react-query';

import { FileService } from './fileService';
import { FileKey } from './keys';

export function useGetFileQuery(id?: string, enabled = true) {
  return useQuery({
    queryKey: [FileKey.FILES, id],
    queryFn: () => FileService.getFile(id).then((response) => response.data),
    enabled: enabled && !!id,
  });
}
